module.exports = __webpack_public_path__ + "img/img-2.85f36bd2.png";